export default "__VITE_ASSET__147eebf1__"